import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../../../../services/request";
import { API_PATH, PATH } from "../../../../utils/config";
import GallerySkeleton from "../../../Gallery/GallerySkeleton";
import { collectionDeepLink } from "./collectionSearch";

// BUG-953: a Collection's shareable link (`/collection/:collectionId`) only
// carries the folder id -- the gallery route that actually opens a collection
// (`/gallery/:id?collection=<id>`, already consumed by OwnerView/GuestView)
// also needs the OWNER's id. This resolves the owner via
// GET /api/v2/folders/<id>/ (the same detail endpoint UPDATE_FOLDER PATCHes)
// and redirects once, so no new "open a folder" mechanism is needed on either
// side -- just this one missing hop from a bare folder id to the real route.
const CollectionRedirect = () => {
  const { collectionId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    API.get(API_PATH.UPDATE_FOLDER(collectionId))
      .then((res) => {
        if (cancelled) return;
        const ownerId = res?.data?.data?.user;
        navigate(
          ownerId != null
            ? collectionDeepLink(collectionId, ownerId)
            : PATH.GALLERY,
          { replace: true }
        );
      })
      .catch(() => {
        // Private/deleted/not-found collection: land on the gallery root
        // rather than a dead end, same fallback LegacyProfileRedirect uses.
        if (!cancelled) navigate(PATH.GALLERY, { replace: true });
      });
    return () => {
      cancelled = true;
    };
  }, [collectionId, navigate]);

  return <GallerySkeleton />;
};

export default CollectionRedirect;
